import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWishList, action_fetch_wish_list } from "../../../../../../store/actions/global";
import { saveWishListProduct as apiAddToWishList, removeWishListProduct as apiRemoveFromWishList } from "../../../../../../api";
import GeekoEvents from "../../../../../ads/events"
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../components/icon/iconfont";

export default props =>{
	useStyles(classes);
    const { productId, product_type } = props;
    const dispatch = useDispatch();
    const global = useSelector((state) => state.global);
    const { wishlist } = global
	const hasExistInWishList = wishlist?.some(pid => pid === productId);
	const [loading,setLoading] = useState(false);
	const [animat,setAnimat] = useState(false);

    const addToWishList = async () => {
		setLoading(true);
		setAnimat(true);
		setTimeout(()=>{
			setAnimat(false);
		},320);
		if(hasExistInWishList){
			dispatch(setWishList(wishlist?.filter(w => w !== productId)))
			await apiRemoveFromWishList(productId)
		}else{
			dispatch(setWishList([...(wishlist||[]), productId]))
			const response = await apiAddToWishList(productId)
			if (response?.code === 300) {
				window.location.href = `/i/login?redirectUrl=${window.location.href}`
			}else if(response?.code != 200 ){
				if(response?.result){
					alert(response?.result)
				} else {
					console.error(response)
				}
			}
			GeekoEvents.addToWishList({
				productId,
				product_type
			})
		}
		dispatch(action_fetch_wish_list())
		setLoading(false);
	}

    return <span className={`${loading?classes.LoadingDisabled:""} ${classes.AddToWish}`} onClick={addToWishList} >
		<Iconfont className={`${classes.Icon} ${hasExistInWishList?classes.Active:''} ${animat?classes.Anim:""}`}></Iconfont>
    </span>
}